type ThirdPartyServicesDescriptorType = {
  category: string;
  name: string;
  description: string;
  typesOfData: string;
  placeOfProcessing: string;
  privacyPolicyURL: string;
};

const thirdPartyServicesDescriptors: ThirdPartyServicesDescriptorType[] = [
  {
    category: 'Hosting and backend infrastructure',
    name: 'OVH (OVH Groupe SA)',
    description:
      'OVH is a cloud computing company which offers VPS, dedicated servers and other web services.',
    typesOfData: 'platform code and data',
    privacyPolicyURL:
      'https://www.ovhcloud.com/en/terms-and-conditions/privacy-policy/',
    placeOfProcessing: 'France',
  },
  {
    category: 'Platform services and hosting',
    name: 'Cloudflare (Cloudflare Inc.)',
    description:
      'Cloudflare, Inc. is an American company that provides content delivery network services, cloud cybersecurity, DDoS mitigation, and domain registration services.',
    typesOfData:
      'Trackers; various types of data as specified in the privacy policy of the service',
    privacyPolicyURL: 'https://www.cloudflare.com/privacypolicy',
    placeOfProcessing: 'Worldwide',
  },
  {
    category: 'Payments and billing',
    name: 'Stripe (Stripe Inc.)',
    description:
      'Stripe is a payment processing platform that allows businesses to accept payments from customers through their website, e-commerce platform, app, or pretty much anywhere else on the internet.',
    typesOfData:
      'Billing address; email address; first name; last name; payment info; Tracker; Usage Data; various types of Data as specified in the privacy policy of the service.',
    privacyPolicyURL: 'https://stripe.com/privacy',
    placeOfProcessing: 'Worldwide',
  },
  {
    category: 'Infrastructure monitoring',
    name: 'Bugsnag (SmartBear Software Inc.)',
    description:
      'Bugsnag is an app monitoring and stability tool that helps teams build better software. It can help you debug issues that impact user experience.',
    typesOfData:
      'Trackers; various types of data as specified in the privacy policy of the service',
    privacyPolicyURL: 'https://docs.bugsnag.com/legal/privacy-policy/',
    placeOfProcessing: 'United States',
  },
  {
    category: 'Platform services and hosting',
    name: 'Github',
    description:
      'GitHub is a website and cloud-based service that helps developers store and manage their code, as well as track and control changes to their code.',
    typesOfData: 'platform data backups (encrypted)',
    privacyPolicyURL: 'https://docs.github.com/en/site-policy/privacy-policies',
    placeOfProcessing: 'United States',
  },
  {
    category: 'Managing apps and sending messages',
    name: 'OneSignal (OneSignal Inc.)',
    description:
      'OneSignal is a customer engagement solution for Push Notifications, Email, SMS, In-App Messaging, and Live Activities.',
    typesOfData:
      'email, first name, last name, phone number, chat messages, appointment details',
    privacyPolicyURL: 'https://onesignal.com/privacy_policy',
    placeOfProcessing: 'United States',
  },
  /*
  {
    category: 'Collect feedbacks',
    name: 'Feedback Fish (Maximilian Stoiber e.U.)',
    description:
      'Feedback Fish is a simple widget for collecting website feedback from users: problems, suggestions or anything else.',
    typesOfData:
      'email, first name, last name, phone number, chat messages, feedback data',
    privacyPolicyURL: 'https://feedback.fish/help/privacy',
    placeOfProcessing: 'United States',
  },
  */
];

const generateServiceBlock = (descriptor: ThirdPartyServicesDescriptorType) => (
  <div className="mt-4 rounded-lg border-2 border-solid border-gray-200 text-sm">
    <table className="w-full table-fixed border-collapse border border-gray-200 text-center">
      <thead>
        <tr className="border border-gray-200 bg-gray-200">
          <th className="border border-gray-200 p-2">{descriptor.category}</th>
        </tr>
      </thead>
      <tbody />
    </table>
    <table className="w-full table-fixed border-collapse border border-gray-200 text-left">
      <thead>
        <tr className="border border-gray-100 bg-gray-100">
          <th className="border border-gray-100  p-2">Name</th>
          <th className="border border-gray-100  p-2">Types of data</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border border-gray-100 p-2 font-semibold">
            {descriptor.name}
          </td>
          <td className="border border-gray-100 p-2">
            {descriptor.typesOfData}
          </td>
        </tr>
      </tbody>
    </table>
    <table className="w-full table-fixed border-collapse border border-gray-200 text-left">
      <thead>
        <tr className="border border-gray-100 bg-gray-100">
          <th className="border border-gray-100 p-2">Place of processing</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border border-gray-100 p-2">
            <section className="my-2">{descriptor.placeOfProcessing}</section>
          </td>
        </tr>
      </tbody>
    </table>
    <table className="w-full table-fixed border-collapse border border-gray-200 text-left">
      <thead>
        <tr className="border border-gray-100 bg-gray-100">
          <th className="border border-gray-100 p-2">Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border border-gray-100 p-2">
            <section className="my-2">
              {descriptor.description}{' '}
              <a
                href={descriptor.privacyPolicyURL}
                data-test-id="tps-pp-link"
                className="cursor-pointer text-sky-600 hover:text-sky-400"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </section>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

const ThirdPartyServicesGrid = () => (
  <div className="w-full">
    <div className="py-2">
      {thirdPartyServicesDescriptors.map((descriptor) =>
        generateServiceBlock(descriptor),
      )}
    </div>
  </div>
);

export default ThirdPartyServicesGrid;
